import { getAppLogger } from '@tgg/util';

import { applicationIdentifier } from '../constants';

export const appLogger = getAppLogger({
    applicationIdentifier,
});
